import { useDispatch, useSelector } from "react-redux";
import MechanicsSummary from "../../components/MechanicsSummary/MechanicsSummary";
import Navigator from "../../../Common/layouts/Navigator/Navigator";
import {
  selectAxisOptions,
  selectCartesianSteps,
  setAxisOptions,
  setBundleChanged,
  setCartesianCurrentStep
} from "../../store/slices/cartesian";
import { updateConfiguration } from "../../../Common/store/slices/common";
import { showSnackbar } from "../../../Retrofit/store/slices/retrofit";
import t from "../../../Common/utils/translation/translator";
import AxisSection from "./components/AxisSection";

const AxisOptions = ({ ...props }) => {
  const dispatch = useDispatch();
  const steps = useSelector(selectCartesianSteps);
  let axisOptions = useSelector(selectAxisOptions);
  // forces axisOptions to be valid as no bundle is selected
  if (axisOptions?.selectedBundle === undefined || axisOptions?.selectedBundle === null) {
    axisOptions = { ...axisOptions, isValid: true };
  }

  const handleContinue = () => {
    if (axisOptions?.isValid) {
      // Propagates axisOption validation
      dispatch(setAxisOptions({ ...axisOptions, isValid: true }));
      dispatch(setCartesianCurrentStep(steps.FINALIZE_CARTESIAN));
      dispatch(updateConfiguration());
      dispatch(setBundleChanged(null));
    } else {
      dispatch(
        showSnackbar({
          id: "MISSING_OR_INCORRECT_FIELD",
          customMessage: `: ${t("cartesian.ui.axis_options.mountingoption.verify.meesage")}`
        })
      );
    }
  };

  const handlePrevious = () => {
    dispatch(setCartesianCurrentStep(steps.AXIS_SELECTION));
    dispatch(updateConfiguration());
  };

  return (
    <div className="AxisOptions" {...props}>
      <MechanicsSummary data-testid="mechanics-summary" />
      <div className="flex">
        <AxisSection data-testid="axis-section" />
      </div>
      <Navigator
        continueLabel={t("msizer.ui.footer.continue")}
        continueAction={() => {
          handleContinue();
        }}
        continueButtonDisabled={!axisOptions?.isValid}
        previousAction={() => {
          handlePrevious();
        }}
      />
    </div>
  );
};

export default AxisOptions;
